export const baseUrl: string =
  import.meta.env.VITE_BASE_URL?.toString() || 'https://api-nav.triventoeducacao.dev.br/'

export const ldClientId =
  import.meta.env.VITE_LD_CLIENT_ID?.toString() || '6296591c1197e714a71776a6'

export const prodEnv = import.meta.env.PROD

export const ACCESS_TOKEN_KEY = 'nav.professor.accessToken'
export const USER_KEY = 'nav.professor.user'

export const baseUrlFeedback =
  import.meta.env.VITE_FEEDBACK_URL?.toString() ||
  'https://api-feedback.triventoeducacao.dev.br'

export const APPLICATION_ID = 1
